module.exports = __webpack_public_path__ + "6048fcffd7c7a62b655dfb0677e6f4ad.png";